//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Call eliot patch consencts and welcome (Auth)
     * @return Eliot welcome success
     */
    welcome( cancelToken?: CancelToken | undefined): Promise<DefaultRoomDTO[]> {
        let url_ = this.baseUrl + "/welcome";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWelcome(_response);
        });
    }

    protected processWelcome(response: AxiosResponse): Promise<DefaultRoomDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DefaultRoomDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DefaultRoomDTO[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Generic error", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DefaultRoomDTO[]>(null as any);
    }
}

export class DefaultRoomDTO implements IDefaultRoomDTO {
    type?: RoomType;
    count?: number;
    icon?: string | undefined;
    label?: string | undefined;

    constructor(data?: IDefaultRoomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.count = _data["count"];
            this.icon = _data["icon"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): DefaultRoomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultRoomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["count"] = this.count;
        data["icon"] = this.icon;
        data["label"] = this.label;
        return data;
    }
}

export interface IDefaultRoomDTO {
    type?: RoomType;
    count?: number;
    icon?: string | undefined;
    label?: string | undefined;
}

/** 0 = Livingroom 1 = Bathroom 2 = Kitchen 3 = Bedroom 4 = Dining_room 5 = Toilets 6 = Lobby 7 = Corridor 8 = Garage 9 = Outdoor 10 = Home_office 11 = Stairs 12 = Electrical_cabinet 13 = Custom 14 = Unknown */
export enum RoomType {
    Livingroom = 0,
    Bathroom = 1,
    Kitchen = 2,
    Bedroom = 3,
    Dining_room = 4,
    Toilets = 5,
    Lobby = 6,
    Corridor = 7,
    Garage = 8,
    Outdoor = 9,
    Home_office = 10,
    Stairs = 11,
    Electrical_cabinet = 12,
    Custom = 13,
    Unknown = 14,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}